import moment from 'moment'
export default {
  methods: {
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      if (format === 'ago') {
        const now = moment()
        const input = moment(date)
        const diffSeconds = now.diff(input, 'seconds')
        if (diffSeconds < 60) {
          return '刚刚'
        } else if (diffSeconds < 3600) {
          return `${Math.floor(diffSeconds / 60)}分钟前`
        } else if (diffSeconds < 86400) {
          return `${Math.floor(diffSeconds / 3600)}小时前`
        } else if (diffSeconds < 2592000) {
          return `${Math.floor(diffSeconds / 86400)}天前`
        } else if (diffSeconds < 31536000) {
          return `${Math.floor(diffSeconds / 2592000)}月前`
        } else {
          return `${Math.floor(diffSeconds / 31536000)}年前`
        }
      }
      return moment(date).format(format)
    },
    getAsset(user, type) {
      return user.assets.find((asset) => asset.type === type)
    },
    confirmDelete(id, api) {
      return new Promise((resolve) => {
        this.$dialog
          .confirm({
            title: '提示',
            message: '确定删除吗？',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
          .then(async () => {
            const loading = this.$toast.loading('操作中...')
            try {
              await this.$post(api, {
                id: id
              })
              this.$toast.success('删除成功')
              resolve()
            } catch (error) {
              this.$alertError(error)
            } finally {
              loading.clear()
            }
          })
          .catch(() => {})
      })
    }
  }
}
